module.exports = __webpack_public_path__ + "static/media/icono_dislike_lleno.4181e045.svg";